var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCawiCapi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 71,
    viewBox: "0 0 77 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: 13,
    fill: "#FFDCE3",
    fillRule: "nonzero",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    fillRule: "nonzero",
    d: "M48 17v16a2 2 0 1 0 4 0V17a2 2 0 1 0-4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M50 41v16M20 57v11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    fillRule: "nonzero",
    d: "M58.848 31H6.11c-.273 0-.837-.28-1.338-.76C4.277 29.764 4 29.245 4 29a2 2 0 1 0-4 0c0 2.915 3.214 6 6.11 6H59a2 2 0 0 0 .266-.018 6.66 6.66 0 0 0 5.716-5.716A2 2 0 0 0 65 29v-7a2 2 0 1 0-4 0v6.848A2.66 2.66 0 0 1 58.848 31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    fillRule: "nonzero",
    d: "M61 21.152V29a2 2 0 1 0 4 0v-8a2 2 0 0 0-.018-.266 6.66 6.66 0 0 0-5.716-5.716A2 2 0 0 0 59 15H6.11c-3.295.109-5.911 2.655-6.106 5.879a2 2 0 1 0 3.992.242 2.26 2.26 0 0 1 2.18-2.122L58.849 19A2.66 2.66 0 0 1 61 21.152z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M63 46v7a4.66 4.66 0 0 1-4 4H6.11C4.33 57 2 54.82 2 53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M2 45c0-1.82 2.33-4 4.11-4H59a4.66 4.66 0 0 1 4 4v8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.997,
    cy: 25.005,
    r: 3,
    fill: "#F7465F",
    fillRule: "nonzero",
    transform: "rotate(-30 9.997 25.005)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.997,
    cy: 49,
    r: 3,
    fill: "#F7465F",
    fillRule: "nonzero",
    transform: "rotate(-30 9.997 49)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M3 69h58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCawiCapi);
export default __webpack_public_path__ + "static/media/cawi-capi.415b26d0a520f2c97867254c7a5dcf94.svg";
export { ForwardRef as ReactComponent };